export class SearchCriteria {
  SearchTerm: string;
  Sort: string;
  Order: string;
  PageNumber: number;

  constructor() {}
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/models/search-criteria.model.ts